<template>
  <div class="item-description-link-area">
    <p v-if="heading" class="item-description-link-heading">
      {{ heading }}
    </p>
    <p v-if="description" class="item-description-link-description">
      {{ description }}
    </p>
    <a
      v-if="safeUrl"
      :href="safeUrl"
      target="_blank"
      rel="noopener noreferrer"
      class="item-description-link-url"
    >
      {{ displayText || url }}
    </a>
    <span v-else class="item-description-link-url">
      {{ displayText || url }}
    </span>
  </div>
</template>

<script>
import { sanitizeUrl } from '../../../utils/UrlSanitizer.js'

export default {
  name: 'ItemDescriptionLink',
  props: {
    url: {
      type: String,
      required: true
    },
    description: {
      type: String,
      default: ''
    },
    heading: {
      type: String,
      default: ''
    },
    displayText: {
      type: String,
      default: ''
    }
  },
  computed: {
    safeUrl() {
      return sanitizeUrl(this.url)
    }
  }
}
</script>

<style lang="scss" scoped>
.item-description-link-area {
  display: flex;
  flex-direction: column;
  gap: 8px;
  border-radius: 4px;
  border: 1px solid $gray-2;
  background: $gray-3;
  padding: 16px;
  font-size: 1.4rem;
  font-style: normal;
  line-height: 1.6;
  letter-spacing: 0.56px;
}

.item-description-link-heading {
  color: $gray-1;
  font-weight: bold;
}

.item-description-link-description {
  color: $gray-1;
}

.item-description-link-url {
  color: $link;
  overflow-wrap: break-word;
  word-break: break-all;
}
</style>
